package gr.tech.GRAttestation.components.modals

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.toAttrs
import gr.tech.GRAttestation.sections.forms.StoreForm
import gr.tech.GRAttestation.models.stores.StoreDTO
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.Text

@Composable
fun StoreInputModal(
    modalId: String,
    storeInformation: StoreDTO,
    formError: String,
    onSubmit: (StoreDTO) -> Unit,
    onClose: () -> Unit,
) {
    Div(
        attrs = Modifier
            .classNames("modal", "fade")
            .id(modalId)
            .toAttrs {
                attr("tabindex", "-1")
                attr("data-bs-backdrop", "static")
            }
    ) {
        Div(
            attrs = Modifier.classNames("modal-dialog").toAttrs()
        ) {
            Div(
                attrs = Modifier.classNames("modal-content").toAttrs()
            ) {
                // Header
                Div(
                    attrs = Modifier.classNames("modal-header").toAttrs()
                ) {
                    H5(attrs = Modifier.classNames("modal-title").toAttrs()) {
                        Text("Confirm")
                    }
                    Button(
                        attrs = Modifier.classNames("btn-close").onClick { onClose() }.toAttrs {}
                    )
                }

                // Body
                Div(
                    attrs = Modifier.classNames("modal-body").toAttrs()
                ) {
                    key(storeInformation) {
                        StoreForm(
                            storeInformation = storeInformation,
                            formError = formError,
                            onSubmit = { onSubmit(it) }
                        )
                    }
                }
            }
        }
    }
}